import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface ZoomControlsProps {
  handleZoomIn: () => void
  handleZoomOut: () => void
}

export const ZoomControls = ({
  handleZoomIn,
  handleZoomOut,
}: ZoomControlsProps) => {
  return (
    <div className={s.zoomControls}>
      <button
        className={s.zoomButton}
        onClick={handleZoomIn}
      >
        <AppIcon
          id={AllIcons.PLUS}
          width={20}
          height={20}
        />
      </button>
      <button
        className={s.zoomButton}
        onClick={handleZoomOut}
      >
        <AppIcon
          id={AllIcons.MINUS}
          width={20}
          height={20}
        />
      </button>
    </div>
  )
}
